<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="mypooq-info-body">
        <div class="wrap">
          <div class="my-c-wrap">
            <h3 class="my-c-tit" tabindex="0">보유 쿠폰내역</h3>
            <div class="my-coupon-top">
              <form class="my-coupon-input">
                <fieldset>
                  <legend>쿠폰등록 양식</legend>
                  <label>
                    <input
                      v-model="couponText"
                      type="text"
                      placeholder="쿠폰번호를 입력해 주세요."
                      class="my-coupon-num"
                      title="쿠폰번호 입력영역"
                      @input="changeCouponText()"
                    />
                  </label>
                  <input
                    type="submit"
                    value="쿠폰등록"
                    class="submit-coupon"
                    title="쿠폰등록버튼"
                    @click.prevent="executeCouponRegister()"
                  />
                </fieldset>
              </form>
              <ul class="my-coupon-noti">
                <li
                  v-for="(item, index) in notificationLeft"
                  :key="`notification_left_${index}`"
                >
                  <p class="dot-text">
                    <span v-html="item.replaceAll('\n', '<br>')"></span>
                  </p>
                </li>
              </ul>
              <ul class="my-coupon-noti">
                <li
                  v-for="(item, index) in notificationRight"
                  :key="`notification_right_${index}`"
                >
                  <p class="dot-text">
                    <span v-html="item.replaceAll('\n', '<br>')"></span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="my-c-wrap">
            <ul class="my-sub-nav">
              <li>
                <button
                  type="button"
                  :class="viewType === 'property' ? 'my-sub-nav-on' : ''"
                  @click.prevent="setTab('property')"
                >
                  보유 쿠폰
                </button>
              </li>
              <li>
                <button
                  type="button"
                  :class="viewType === 'using' ? 'my-sub-nav-on' : ''"
                  @click.prevent="setTab('using')"
                >
                  소진 쿠폰
                </button>
              </li>
            </ul>
            <table v-if="dataList && dataList.length !== 0" class="my-c-table">
              <caption class="blind">
                {{
                  cationText
                }}
              </caption>
              <colgroup>
                <col />
                <col style="width: 311px" />
                <col v-if="viewType === 'using'" style="width: 141px" />
                <col style="width: 141px" />
              </colgroup>
              <thead>
                <tr>
                  <th><p class="al">쿠폰명</p></th>
                  <th><p class="al">지급사유</p></th>
                  <th v-if="viewType === 'property'">만료일자</th>
                  <th v-if="viewType === 'using'">상태</th>
                  <th v-if="viewType === 'using'">일자</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in dataList"
                  :key="index"
                  :class="data.couponstate === '만료' ? 'coin-expire' : ''"
                >
                  <td>
                    <p class="al">
                      <span v-if="data.status === '이용중'" class="badge ui"
                        >이용중</span
                      >{{ data.couponname }}
                      <button
                        v-if="
                          data.usable === 'y' && data.coupontype === 'voucher'
                        "
                        class="use-coupon-btn"
                        @click="executeCouponUse(data.couponnumber)"
                      >
                        사용하기
                      </button>
                    </p>
                  </td>
                  <td>
                    <p class="al">{{ data.description }}</p>
                  </td>
                  <td v-if="viewType === 'using'">{{ data.couponstate }}</td>
                  <td>{{ data.enddate }}</td>
                </tr>
              </tbody>
            </table>

            <div v-if="dataList && dataList.length === 0" class="my-c-empty">
              <empty-list :text="emptyText"></empty-list>
            </div>

            <!-- 페이징 -->
            <paging-component
              v-if="dataList && dataList.length !== 0"
              :current-page="currentPage"
              :page-count="pageCount"
              :limit="limit"
              :paging-count="10"
              wrapper-class="paging-type02"
            />
          </div>
        </div>
      </div>
    </section>
    <PopupRegisterEmail
      v-if="isShowPopup"
      @on-click-close="closePopup"
      @on-click-submit="couponRegister"
    />
    <LoadingBar v-if="isLoading" />
  </div>
</template>

<script>
  import _ from 'lodash'
  import PagingComponent from '@/components/common/PagingComponent'
  import {
    postMycouponsActivate,
    postMycouponsRegister,
    getMyCouponsList,
  } from '@/common/utils/request'
  import constant from '@/common/resources/constant'
  import EmptyList from '@/components/mypooq/EmptyList'
  import queryString from '@/common/utils/querystring'
  import {
    commonErrorProcess,
    scrollTop,
    titleTagNameChange,
    showBillingCouponPopup,
  } from '@/common/utils/common'
  import { PATH_NAME_COIN } from '@/common/resources/router.const'
  import { getCouponCheckUseAction } from '@/common/requests/data-fetch/get-coupon-check-use-action'
  import { getCouponCheckRegisterAction } from '@/common/requests/data-fetch/get-coupon-check-register-action'
  import { REGISTER_ACTION_TYPE } from '@/common/normalize/normalize-check-register-action'
  import { USE_ACTION_TYPE } from '@/common/normalize/normalize-check-use-action'
  import {
    MSG_COUPON_IN_APP,
    MSG_COUPON_INVALID,
    MSG_COUPON_SERVER_ERROR,
    MSG_USING_COUPON_ALREADY,
    COUPON_NOTIFICATION_LIST,
  } from '@/common/utils/coupon/const'
  import PopupRegisterEmail from '@/components/mypooq/PopupRegisterEmail.vue'
  import LoadingBar from '@/components/ui/LoadingBar/LoadingBar.vue'

  export default {
    components: {
      LoadingBar,
      PopupRegisterEmail,
      PagingComponent,
      EmptyList,
    },
    data() {
      return {
        viewType: queryString.getQueryParamValue(
          this.$route,
          'viewType',
          'property',
        ),
        dataList: undefined,
        couponText: '',
        couponTextLength: 0,
        currentPage: +queryString.getQueryParamValue(this.$route, 'page', '1'),
        limit: 15,
        pageCount: 0,
        typedCouponNumber: '',
        isShowPopup: false,
        isLoading: false,
        notificationLeft: COUPON_NOTIFICATION_LIST.slice(0, 4),
        notificationRight: COUPON_NOTIFICATION_LIST.slice(4),
      }
    },
    computed: {
      emptyText() {
        return this.viewType === 'property'
          ? '보유 쿠폰이 없어요.'
          : '소진된 쿠폰이 없어요.'
      },
      cationText() {
        return this.viewType === 'property'
          ? '보유 쿠폰 내역'
          : '소진 쿠폰 내역'
      },
    },
    created() {
      window.addEventListener('message', this.postMessage)
      this.setData()
      titleTagNameChange('쿠폰내역 : 웨이브 MY')
    },
    beforeDestroy() {
      window.removeEventListener('message', this.postMessage)
    },
    methods: {
      postMessage(e) {
        if (e.origin === location.origin) {
          if (e.data?.eventMessage === 'PaymentCoupon') {
            window.location.reload(true)
          }
        }
      },
      showPopupEmail() {
        this.isShowPopup = true
      },
      closePopup() {
        this.isShowPopup = false
        this.couponText = ''
      },
      showPopupPayment(couponNumber) {
        const ACTION_PATH = 'PaymentCoupon'

        let locationOrigin = window.location.origin
        if (!locationOrigin) {
          locationOrigin = `${window.location.protocol}//${window.location.hostname}`
        }
        const returnUrl = `${locationOrigin}/callback.html?action=${ACTION_PATH}`
        const canceledUrl = `${locationOrigin}/callback.html?action=Cancel`

        showBillingCouponPopup({
          couponNumber,
          returnUrl,
          canceledUrl,
        })
      },
      // 쿠폰 번호가 입력되면 4자리마다 '-' 추가
      changeCouponText() {
        let couponText = this.couponText.replace(/-/g, '')
        let changeText = ''
        for (let i = 0; i < Math.ceil(couponText.length / 4); i++) {
          if (i !== 0) {
            changeText += '-'
          }
          changeText += couponText.slice(
            i * 4,
            Math.min(couponText.length, i * 4 + 4),
          )
        }
        this.couponText = changeText
      },
      setTab(type) {
        this.$router.push({
          query: {
            viewType: type,
          },
        })
      },
      throwError(error) {
        const serverErrorRegExp = /^500/gi
        this.couponText = ''

        if (serverErrorRegExp.test(error?.data?.code)) {
          window.alert(MSG_COUPON_SERVER_ERROR)
          return undefined
        }

        window.alert(error?.data?.data?.message || MSG_COUPON_INVALID)
      },
      async getActionType(callback) {
        if (!callback) {
          return undefined
        }

        const { data, error } = await callback()
        const actionType = data?.actionType

        if (!actionType) {
          return this.throwError(error)
        }

        return actionType
      },
      // 쿠폰 사용하기
      usingCoupon(couponNumber) {
        postMycouponsActivate({ couponnumber: couponNumber }).then(() => {
          // viewType 재설정 및 URL 재호출
          this.$router.push({
            name: 'coupon',
            query: {
              viewType: 'using',
            },
          })
        })
      },
      async executeCouponUse(couponNumber) {
        this.isLoading = true
        const actionType = await this.getActionType(() =>
          getCouponCheckUseAction({ couponNumber }),
        )
        this.isLoading = false

        const {
          SHOW_ALERT_INAPP,
          SHOW_ALERT_USE_PRODUCT,
          USE_COUPON,
          SHOW_POPUP_REGIST_RECURRING,
        } = USE_ACTION_TYPE

        switch (actionType) {
          case SHOW_ALERT_INAPP: {
            window.alert(MSG_COUPON_IN_APP)
            break
          }

          case SHOW_ALERT_USE_PRODUCT: {
            window.alert(MSG_USING_COUPON_ALREADY)
            break
          }

          case USE_COUPON: {
            this.usingCoupon(couponNumber)
            break
          }

          case SHOW_POPUP_REGIST_RECURRING: {
            this.showPopupPayment(couponNumber)
            break
          }
        }
      },
      couponRegister(email = '') {
        postMycouponsRegister({ couponnumber: this.typedCouponNumber, email })
          .then((response) => {
            if (response.data.coupontypeid === '3') {
              if (confirm(constant.MSG_MOVING_MYPOOQ_COIN)) {
                this.$router.push({ name: PATH_NAME_COIN })
              } else {
                window.location.reload(true)
              }
            } else {
              alert(constant.MSG_MYPOOQ_COUPON_COMPLETE)
              window.location.reload(true)
            }
          })
          .catch(commonErrorProcess)
      },
      // 쿠폰등록
      async executeCouponRegister() {
        this.typedCouponNumber = this.couponText.replace(/-/g, '').trim()

        if (this.typedCouponNumber.length === 0) {
          alert(constant.MSG_MYPOOQ_COUPON_NO_VALUE)
          this.couponText = ''
          return undefined
        }

        this.isLoading = true
        const actionType = await this.getActionType(() =>
          getCouponCheckRegisterAction({
            couponNumber: this.typedCouponNumber,
          }),
        )
        this.isLoading = false

        const {
          SHOW_POPUP_EMAIL_REGISTER_COUPON,
          REGISTER_COUPON,
          SHOW_ALERT_INAPP,
        } = REGISTER_ACTION_TYPE

        switch (actionType) {
          case SHOW_ALERT_INAPP:
            window.alert(SHOW_ALERT_INAPP)
            break

          case SHOW_POPUP_EMAIL_REGISTER_COUPON:
            this.showPopupEmail()
            break

          case REGISTER_COUPON:
            this.couponRegister()
            break
        }
      },
      setData() {
        const offset = this.limit * (this.currentPage - 1)
        let status = this.viewType === 'property' ? 'y' : 'n'
        getMyCouponsList({
          coupontype: 'all',
          status,
          offset,
          limit: this.limit,
          orderby: 'new',
        }).then(({ data }) => {
          this.dataList = _.get(data, 'list', [])
          this.pageCount = Number(_.get(data, 'pagecount', '0'))
        })
        scrollTop()
      },
    },
  }
</script>
